export interface SingleCommitmentDetails {
	commitmentPenaltyAmount: number;
	endDate: string;
	name: string;
	pendingPeriods: number;
	rate: number;
	remainingAmount: number;
	startDate: string;
	status: string;
	totalAmount: number;
	totalPeriods: number;
	productId: string;
}

const model: types.models.InputModel = {
	commitmentPenaltyAmount: 'commitmentPenaltyAmount',
	endDate: 'endDate',
	name: 'name',
	pendingPeriods: 'pendingPeriods',
	rate: 'rate',
	remainingAmount: 'remainingAmount',
	startDate: 'startDate',
	status: 'status',
	totalAmount: 'totalAmount',
	totalPeriods: 'totalPeriods',
	productId: 'productId'
};

export default model;
